namespace $ {
	export class $shm_hitalama_chat_room_personal extends $giper_baza_entity.with({

		Draft_message: $giper_baza_text,
		Agent_map_drafts: $giper_baza_dict_to( $giper_baza_text ),

	}){
		
		draft_message( next?: string ) {
			return this.Draft_message(next)?.value(next) ?? ''
		}

		agent_map_draft( map_id: string, next?: string ) {
			if( !map_id ) return ''
			if( next === undefined ) return this.Agent_map_drafts()?.key( map_id )?.value() ?? ''
			return this.Agent_map_drafts( null )?.key( map_id, 'auto' )?.value( next ) ?? ''
		}
		
	}
}
